
/* Change this file to get your personal Portfolio */

// Your Summary And Greeting Section

import emoji from "react-easy-emoji";

const greeting = {
  /* Your Summary And Greeting Section */
  username: "Baha Bilgin",
  title: "Hey, I'm Baha",
  subTitle: emoji("A passionate Software Developer 🚀 having experience in building `cross-platform` applications with JavaScript libraries and frameworks."),
  resumeLink: "https://docs.google.com/document/d/1TPnaKrXWbGe1TCQB9o_q0Ngxw0x0bArkYOosdt52jdw/edit?usp=sharing"
};

// Your Social Media Link

const socialMediaLinks = {

  github: "https://github.com/bahablgn",
  // linkedin: "https://www.linkedin.com/in/bahabilgin/",
  // gmail: "bahabilgin@gmail.com",
  // instagram: "https://www.instagram.com/bahablgn/",
  // gitlab: "https://gitlab.com/saadpasta",
  // facebook: "https://www.facebook.com/saad.pasta7",
  // medium: "https://medium.com/@saadpasta",
  // stackoverflow: "https://stackoverflow.com/users/10422806/saad-pasta"
  // Instagram and Twitter are also supported in the links!
};

// Your Skills Section

const skillsSection = {
  title: "What I Do",
  subTitle: "SOFTWARE DEVELOPER WHO WANTS TO EXPLORE EVERY TECH STACK",
  skills: [
    emoji("⚡ Developing highly interactive UI for web and mobile applications"),
    emoji("⚡ Building cross-platform desktop and mobile apps with JavaScript libraries and frameworks like Vue.js, Cordova.js, Electron.js and some cool others"),
    emoji("⚡ Creating application backend with Node Express or PHP"),
    emoji("⚡ Using SQL and NoSQL database systems and services like MongoDB, MySql MariaDB, Google Cloud Firestore"),    
    emoji("⚡ Recently exploring the 'Computer Vision' with Python, Tensorflow, OpenCV image segmentation and object detection")
  ],

/* Make Sure You include correct Font Awesome Classname to view your icon
https://fontawesome.com/icons?d=gallery */

  softwareSkills: [
    {
      skillName: "html-5",
      fontAwesomeClassname: "fab fa-html5"
    },
    {
      skillName: "css3",
      fontAwesomeClassname: "fab fa-css3-alt"
    },
    {
      skillName: "JavaScript",
      fontAwesomeClassname: "fab fa-js"
    },
    {
      skillName: "nodejs",
      fontAwesomeClassname: "fab fa-node"
    },
    {
      skillName: "Vue.js",
      fontAwesomeClassname: "fab fa-vuejs"
    },
    {
      skillName: "firebase",
      fontAwesomeClassname: "fas fa-fire"
    },
    {
      skillName: "Phonegap",
      fontAwesomeClassname: "fab fa-adobe"
    },  
    
    {
      skillName: "PHP",
      fontAwesomeClassname: "fab fa-php"
    },    
    {
      skillName: "sql-database",
      fontAwesomeClassname: "fas fa-database"
    },
    
    
    {
      skillName: "python",
      fontAwesomeClassname: "fab fa-python"
    },
    {
      skillName: "electron.js",
      fontAwesomeClassname: "fab fa-react"
    }
  ]
};

// Your top 3 proficient stacks/tech experience

const techStack = {
  viewSkillBars: true, //Set it to true to show Proficiency Section
  experience: [
    {
      Stack: "Front End",  //Insert stack or technology you have experience in
      progressPercentage: "90%"  //Insert relative proficiency in percentage
    },
    {
      Stack: "Back End",
      progressPercentage: "70%"
    },
    {
      Stack: "Digital Marketing",
      progressPercentage: "40%"
    }
  ]
};


// Your top 3 work experiences

const workExperiences = {
  viewExperiences: true, //Set it to true to show workExperiences Section
  experience: [
    {
      role: "Sr. Front End Developer",  
      company: "Mercury Inc, Boston, MA (Remote)",
      companylogo: require("./assets/images/mercury-logo-2.png"),
      bgcolor : '#EE533E',
      date: "March 2023 - Present",
      desc: "Boston-Based Shipping and Logistics Organization",      
      descBullets: [
        "Being a part of a great dev team to develop and maintain Portal & Cental shipping application that based on Angular 14^ & PrimeNG UI",
        "Develop and bugfix of various components, implement wireframes to code and support the team in every development stages."
      ]     
    },
    {
      role: "Sr. Front End Developer",  
      company: "LINGA rOS Inc, Florida (Remote)",
      companylogo: require("./assets/images/linga-logo.png"),
      bgcolor : '#E51892',
      date: "November 2022 – March 2023",
      desc: "rOS Solutions company, lingaros.com",      
      descBullets: [
        "Revamped the back office of the restaurant operating system that uses Angular.js to Angular 14.",
        "Developed various components for rOS to boost user experience such as canvas drawing tool with Fabric.js, excell template import/export and preview on editable data-grid, tab shows, accordions, drawers and some cool other Material-UI components and front-end techniques"
      ]     
    },
    {
      role: "Software Developer",  
      company: "Nureva Inc, Calgary (Remote)",
      companylogo: require("./assets/images/nureva.png"),
      bgcolor : '#0099cc',
      date: "June 2020 – Present",
      desc: "Audi/Video solutions for hybrid learning and business, nureva.com",      
      descBullets: [
        "Executed and contributed to full-stack cross-platform app development, with an emphasis on front-end features, browser manipulation, and cross-browser compatibility.",
        "Contributed to fully functional cross platform app based on company requirements using Angular8-13 and Electron.js"
      ]     
    },
    {
      role: "Co-founder & Director",  
      company: "Web4North, Toronto",
      companylogo: require("./assets/images/web4north.png"),
      bgcolor : '#09d3ac',
      date: "",
      descBullets: [
        "Development planning and design for web and mobile apps, landing pages, using Agile Project Management.",
        "Helping other companies to grow their business around the globe.",
        "Executed and contributed to full-stack web development projects, with an emphasis on front-end features, browser manipulation, and cross-browser compatibility.",
        "Developed fully functional responsive prototypes based on Business Requirements using HTML5, CSS3, JavaScript libraries and frameworks"      
      ]     
    },
    {
      role: "e-Commerce Developer & Operator",  
      company: "Home Blinds CA, Toronto",
      companylogo: require("./assets/images/home-blinds.png"),
      bgcolor : '#b3669f',
      date: "Fab 2020 – June 2020",
      desc: "Canadian home blinds company, homeblinds.ca",      
      descBullets: [
        "Designed, developed and maintained an entire business e-Commerce website for the company of Paramount Interior Design",        
        "Provided internet related services including domain name registration, web and e-mail hosting, search engine optimization/submission, google ads management."
        
      ]
    },
    {
      role: "Front-End Developer",   
      company: "Infoline Information Technologies, Ankara",
      companylogo: require("./assets/images/infiline-logo.png"),
      bgcolor : '#d71736',
      date: "May 2017 – July 2018",
      descBullets: [
        "Develop and maintain cross-platform learning management system and smart board application to Ministry of Education by using Node.js, Electron.js, and Cordova.js",
        "Collaborating closely with the team to support projects during the all phases"
      ]
    },
    {
      role: "Start-Up Project Manager",   
      company: "Honeymoonline, Ankara",
      companylogo: require("./assets/images/honeymoonline-logo.jpg"),
      bgcolor : '#01adef',
      date: "Jan 2017 – May 2017",
      descBullets: [
        "Collaborating and managing the project team",
        "Monitoring and controlling the project work and managing any necessary changes",
        "Validating and controlling the scope of the project",
        "Supporting developer team for PHP CodeIgniter framework and SQL queries",
      ]
    },
    {
      role: "Front End Developer & Designer",  
      company: "Crocus Media, Ankara",
      companylogo: require("./assets/images/crocus_logo.png"),
      date: "Dec 2014 – Jan 2017",
      descBullets: [
        "Implemented cross platform apps and landing pages from concept through deployment.",
        "Designed and managed e-commerce, Joomla / Wordpress websites, blogs, design logos, catalogs and mockups",
        "Created highly effective marketing campaigns, product presentations, and trade show materials."
      ]
    },
  ]
};

/* Your Open Source Section to View Your Github Pinned Projects
To know how to get github key look at readme.md */

const openSource = {
  githubConvertedToken: process.env.REACT_APP_GITHUB_TOKEN,
  githubUserName: "bahablgn", // Change to your github username to view your profile in Contact Section.
  showGithubProfile :"true" // Set true or false to show Contact profile using Github, defaults to false 
};


// Some Big Projects You have worked with your company

const bigProjects = {
  title: "Big Projects",
  subtitle: "SOME STARTUPS AND COMPANIES THAT I HELPED TO CREATE THEIR TECH",
  projects: [
    {
      // image: require("./assets/images/saayaHealthLogo.webp"),
      link: ""
    },
    {
      // image: require("./assets/images/nextuLogo.webp"),
      link: ""
    }
  ]
};

// Your Achievement Section Include Your Certification Talks and More

const achievementSection = {

  title: emoji("My Recent Work 🏆 "),
  subtitle: "SOME STARTUPS AND COMPANIES THAT I HELPED TO CREATE THEIR TECH",

  achivementsCards: [
    {
      title: "Coming soon...",
      subtitle: "-",
      image: require("./assets/images/googleAssistantLogo.webp"),
      footerLink: [
        { name: "-", url: "-" }
      ]
    },
     {
      title: "Coming soon...",
      subtitle: "-",
      image: require("./assets/images/googleAssistantLogo.webp"),
      footerLink: [
        { name: "-", url: "-" }
      ]
    },
     {
      title: "Coming soon...",
      subtitle: "-",
      image: require("./assets/images/googleAssistantLogo.webp"),
      footerLink: [
        { name: "-", url: "-" }
      ]
    }
  ]
};

// Blogs Section

const blogSection = {

  title: "Blogs",
  subtitle: "With Love for Developing cool stuff, I love to write and teach others what I have learnt.",

  blogs: [
    {
      url: "https://blog.usejournal.com/create-a-google-assistant-action-and-win-a-google-t-shirt-and-cloud-credits-4a8d86d76eae",
      title: "Win a Google Assistant Tshirt and $200 in Google Cloud Credits",
      description: "Do you want to win $200 and Google Assistant Tshirt by creating a Google Assistant Action in less then 30 min?"
    },
    {
      url: "https://medium.com/@saadpasta/why-react-is-the-best-5a97563f423e",
      title: "Why REACT is The Best?",
      description: "React is a JavaScript library for building User Interface. It is maintained by Facebook and a community of individual developers and companies."
    }
  ]
};

// Talks Sections

const talkSection = {
  title: "TALKS",
  subtitle: emoji("I LOVE TO SHARE MY LIMITED KNOWLEDGE AND GET A SPEAKER BADGE 😅"),

  talks: [
    {
      title: "Build Actions For Google Assistant",
      subtitle: "Codelab at GDG DevFest Karachi 2019",
      slides_url: "https://bit.ly/saadpasta-slides",
      event_url: "https://www.facebook.com/events/2339906106275053/"
    }
  ]
};

// Podcast Section

const podcastSection = {
  title: emoji("Podcast 🎙️"),
  subtitle: "I LOVE TO TALK ABOUT MYSELF AND TECHNOLOGY",

  // Please Provide with Your Podcast embeded Link
  podcast: ["https://anchor.fm/codevcast/embed/episodes/DevStory---Saad-Pasta-from-Karachi--Pakistan-e9givv/a-a15itvo"]
};

const contactInfo = {
  title: emoji("Contact Me ☎️"),
  subtitle: "Discuss a project or just want to say hi? My Inbox is open for all.",
  number: "+92-",
  email_address: "@gmail.com"
};

//Twitter Section

const twitterDetails = {

  userName : "twitter"//Replace "twitter" with your twitter username without @
  
};
export { greeting, socialMediaLinks, skillsSection, techStack, workExperiences, openSource, bigProjects, achievementSection, blogSection, talkSection, podcastSection, contactInfo , twitterDetails};
